import packagesService from "@/modules/packages/services/packagesService.js";


const state = {
  packages: [],
  businessPackages: [],
};

const getters = {
  packages: (state) => state.packages,
  businessPackages: (state) => state.businessPackages,
};

const mutations = {
  setPackages(state, packages) {
    state.packages = packages
  },
  setBusinessPackages(state, packages) {
    state.businessPackages = packages
  }
}

const actions = {
  async loadPackages({commit, state}, {client_uid, matter_uid = null}) {
    let packages = await packagesService.getClientPackages({client_uid, matter_uid})
    packages = packagesService.removeExpiredPacakges(packages.data.client_packages)
    commit('setPackages', packages)
    return packages
  },
  async loadBusinessPackages({commit, state}) {
    let packages = await packagesService.getBusinessPackages()
    packages = packagesService.removeNonActivePacakges(packages.data.packages)
    commit('setBusinessPackages', packages)
    return packages
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
